import React, { useEffect, useState } from "react";
import { ScheduleADemo, Share } from "./layoutSections/LayoutSection";
import ContactForm from "../components/forms/ContactForm";
import ContactForm1 from "../components/forms/ContactForm1";
import ContactForm2 from "../components/forms/ContactForm2";
import ContactForm3 from "../components/forms/ContactForm3";
import { RenderSvg, ScreenSize } from "../utils/helpers/helper";
export const Popup = ({
  openPopup,
  setOpenPopup,
  scheduleDemo,
  header,
  IsEmbedded,
  isMobile,
  isVertical,
  contact,
  connect,
  shareLink,
  share,
  selectedForm
}) => {
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  //const [selectedForm, setSelectedForm] = useState(null);
  //const [openPopup, setOpenPopup] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(ScreenSize.isLargeScreen());
    };

    checkScreenSize();
  }, []);

  return (
    <>
      <div
        className={`popup-overlay`}
        style={{
          opacity: openPopup ? "1" : "0",
          zIndex: openPopup ? "9999" : "-9999",
        }}
      >
        {/*<div
          className={`popup-overlay-inner`}
          style={
            header
              ? {
                  width: isMobile ? "100%" : isLargeScreen ? "340px" : "300px",
                  marginTop: isMobile ? (openPopup ? "0" : "-100%") : "auto",
                  marginInline: isMobile ? "0" : "auto",
                  borderRadius: isMobile
                    ? openPopup
                      ? "0 0 22px 22px"
                      : "22px"
                    : "22px",
                  height: isLargeScreen
                    ? "600px"
                    : isVertical
                    ? "500px"
                    : "430px",

                  opacity: openPopup ? "1" : "0",
                }
              : {
                  opacity: openPopup ? "1" : "0",
                  width: share
                    ? "fit-content"
                    : contact
                    ? isMobile
                      ? "90%"
                      : "40vw"
                    : "",
                  ...{ height: contact && isMobile ? "max-content" : {} },
                }
          }
        >
          {scheduleDemo && (
            <ScheduleADemo
              header={header}
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
              isMobile={isMobile}
            />
          )}
          {share && <Share link={shareLink} />}
          {contact && selectedForm === "business development" && (
            <ContactForm
              heading={"Contact Form"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {connect && (
            <ContactForm
              heading={"Contact Form"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {contact && selectedForm === "customer success" && (
            <ContactForm
              heading={"Contact Form"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {contact && selectedForm === "customer support" && (
            <ContactForm
              heading={"Contact Form"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {contact && selectedForm === "1" && (
            <ContactForm1
              heading={"Contact Form"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {contact && selectedForm === "2" && (
            <ContactForm2
              heading={"Contact Form2"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {contact && selectedForm === "ai" && (
            <ContactForm3
              heading={"Contact Form3"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {IsEmbedded ? (
            <></>
          ) : (
            <button
              className={`closeButton ${header ? "headerCloseButton" : ""}`}
              onClick={() => setOpenPopup(null)}
            >
              <RenderSvg
                IconName="times"
                IconType="light"
                style={{ height: "14px" }}
              />
            </button>
          )}
        </div>*/}
        <div
          className={`popup-overlay-inner`}
          style={
            header
              ? {
                  width: isMobile ? "100%" : isLargeScreen ? "340px" : "300px",
                  marginTop: isMobile ? (openPopup ? "0" : "-100%") : "auto",
                  marginInline: isMobile ? "0" : "auto",
                  borderRadius: isMobile
                    ? openPopup
                      ? "0 0 22px 22px"
                      : "22px"
                    : "22px",
                  height:
                  contact && selectedForm === "1"
                  ? "350px"
                  :isLargeScreen
                    ? "600px"
                    : isVertical
                    ? "500px"
                    : "430px",

                  opacity: openPopup ? "1" : "0",
                }
              : {
                  opacity: openPopup ? "1" : "0",
                  width: share
                    ? "fit-content"
                    : contact
                    ? isMobile
                      ? "90%"
                      : "40vw"
                    : "",
                  ...{ height:           
                    contact && selectedForm === "1"
                    ? "350px"
                    : contact && isMobile ? "max-content" : {} },
                }
          }
        >
          {scheduleDemo && (
            <ScheduleADemo
              header={header}
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
              isMobile={isMobile}
            />
          )}
          {share && <Share link={shareLink} />}
          {contact && selectedForm === "business development" && (
            <ContactForm
              heading={"Contact Form"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {connect && (
            <ContactForm
              heading={"Contact Form"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {contact && selectedForm === "customer success" && (
            <ContactForm
              heading={"Contact Form"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {contact && selectedForm === "customer support" && (
            <ContactForm
              heading={"Contact Form"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {contact && selectedForm === "1" && (
            <ContactForm1
              heading={"Contact Form"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {contact && selectedForm === "2" && (
            <ContactForm2
              heading={"Contact Form2"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {contact && selectedForm === "ai" && (
            <ContactForm3
              heading={"Contact Form3"}
              isMobile={isMobile}
              header={header}
              isVertical={isVertical}
              handelContactForm={setOpenPopup}
              openPopup={openPopup}
            />
          )}
          {IsEmbedded ? (
            <></>
          ) : (
            <button
              className={`closeButton ${header ? "headerCloseButton" : ""}`}
              onClick={() => setOpenPopup(null)}
            >
              <RenderSvg
                IconName="times"
                IconType="light"
                style={{ height: "14px" }}
              />
            </button>
          )}
        </div>
      </div>
    </>
  );
};
